/* =========================================================
   MLILY Split Head King product template
   - Build-your-system buy box (mattress feel + optional base)
   - Adds both products to cart in one request (/cart/add.js)
   - Lower sections talk to the buy box through DOM events:
       shk:select-feel  {variantId}   choose a mattress feel
       shk:set-base     {value:bool}  add/remove the base
       shk:toggle-base                flip the base
       shk:state        {variantId, base, total}  broadcast by the buy box
   ========================================================= */
(function () {
  if (window.__shkLoaded) return;
  window.__shkLoaded = true;

  var toastTimer;
  function toast(msg) {
    var t = document.querySelector('.shk-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'shk-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2000);
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function initBuyBox(root) {
    if (root.__shk) return;
    root.__shk = true;

    var currency = root.dataset.currency || 'USD';
    var feels = Array.prototype.slice.call(root.querySelectorAll('[data-shk-feel]'));
    var baseBtns = Array.prototype.slice.call(root.querySelectorAll('[data-shk-base]'));
    var baseId = root.dataset.baseId;
    var baseAvailable = root.dataset.baseAvailable === 'true';
    var basePrice = parseInt(root.dataset.basePrice || '0', 10);
    var baseCompare = parseInt(root.dataset.baseCompare || '0', 10);
    var baseName = root.dataset.baseName || 'Adjustable Base';
    var baseRequired = root.dataset.baseRequired === 'true';
    var systemLabel = root.dataset.systemLabel || '';
    var propKey = root.dataset.propKey || '';

    var el = function (sel) { return root.querySelector(sel); };
    var atcBtn = el('[data-shk-atc]');
    var qtyInput = el('[data-shk-qty]');
    var errorBox = el('[data-shk-error]');
    var sticky = el('[data-shk-sticky]');

    var initialFeel = feels.filter(function (f) { return f.classList.contains('is-on') && !f.disabled; })[0] ||
                      feels.filter(function (f) { return !f.disabled; })[0] || null;

    var state = {
      feel: initialFeel,
      base: !!baseId && baseAvailable && (baseRequired || root.dataset.baseDefault === 'true'),
      qty: 1,
      total: 0
    };

    function feelData(f) {
      return {
        id: f.dataset.variantId,
        name: f.dataset.name,
        price: parseInt(f.dataset.price || '0', 10),
        compare: parseInt(f.dataset.compare || '0', 10),
        mediaId: f.dataset.mediaId
      };
    }

    function setText(sel, txt) {
      root.querySelectorAll(sel).forEach(function (n) { n.textContent = txt; });
    }

    function render() {
      var f = state.feel ? feelData(state.feel) : null;
      var q = state.qty;
      var mPrice = f ? f.price : 0;
      var bPrice = state.base ? basePrice : 0;
      var unit = mPrice + bPrice;
      var total = unit * q;
      var compareUnit = (f ? Math.max(f.compare, f.price) : 0) + (state.base ? Math.max(baseCompare, basePrice) : 0);
      var savings = compareUnit * q - total;

      feels.forEach(function (n) {
        var on = n === state.feel;
        n.classList.toggle('is-on', on);
        n.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      baseBtns.forEach(function (n) {
        var on = (n.dataset.shkBase === 'yes') === state.base;
        n.classList.toggle('is-on', on);
        n.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      setText('[data-shk-price-top]', money(unit, currency));
      setText('[data-shk-price-note]', state.base ? root.dataset.noteSystem : root.dataset.noteMattress);
      setText('[data-shk-sum-mattress]', f ? (f.name + (q > 1 ? ' × ' + q : '')) : '');
      setText('[data-shk-sum-mattress-price]', money(mPrice * q, currency));
      setText('[data-shk-sum-base]', baseName + (q > 1 ? ' × ' + q : ''));
      setText('[data-shk-sum-base-price]', money(basePrice * q, currency));
      setText('[data-shk-sum-total]', money(total, currency));
      root.querySelectorAll('[data-shk-sum-base-row]').forEach(function (r) { r.hidden = !state.base; });

      var saveEl = el('[data-shk-save]');
      if (saveEl) {
        saveEl.hidden = savings <= 0;
        saveEl.textContent = savings > 0 ? (root.dataset.saveLabel || 'You save') + ' ' + money(savings, currency) : '';
      }

      var label = state.base ? root.dataset.labelSystem : root.dataset.labelMattress;
      if (atcBtn && !atcBtn.classList.contains('is-loading')) {
        atcBtn.textContent = f ? label : root.dataset.labelSoldout;
        atcBtn.disabled = !f;
      }
      setText('[data-shk-sticky-name]', f ? (f.name + (state.base ? ' + ' + baseName : '')) : '');
      setText('[data-shk-sticky-price]', money(total, currency));

      // Katapult widget: keep its price in sync with the live system total
      state.total = total;
      var katDollars = (total / 100).toFixed(2);
      root.querySelectorAll('[data-shk-katapult]').forEach(function (w) {
        w.hidden = total <= 0;
        w.querySelectorAll('[data-katapult-item-price]').forEach(function (n) {
          n.setAttribute('data-katapult-item-price', katDollars);
        });
      });
      if (total > 0 && window.katapult && typeof window.katapult.estimatePrice === 'function') {
        try { window.katapult.estimatePrice(); } catch (e) {}
      }

      // Value for other financing widgets that read a price from the page
      root.querySelectorAll('[data-shk-total]').forEach(function (n) {
        n.setAttribute('data-shk-total', total);
        n.setAttribute('data-price', (total / 100).toFixed(2));
      });

      if (qtyInput) qtyInput.value = q;

      document.dispatchEvent(new CustomEvent('shk:state', {
        detail: { variantId: f ? f.id : null, base: state.base, baseAvailable: !!baseId && baseAvailable, baseRequired: baseRequired, total: total }
      }));
    }

    /* ----- gallery: fade stage, arrows, swipe, scrolling thumbnails ----- */
    var stageItems = Array.prototype.slice.call(root.querySelectorAll('[data-shk-stage-item]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-shk-thumb]'));
    var thumbTrack = root.querySelector('[data-shk-thumbs]');
    var current = 0;
    function showIndex(i) {
      if (!stageItems.length) return;
      i = (i + stageItems.length) % stageItems.length;
      current = i;
      stageItems.forEach(function (s, n) {
        var on = n === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      // keep the active thumbnail in view inside the scrolling strip
      var t = thumbs[i];
      if (thumbTrack && t) {
        var left = t.offsetLeft - (thumbTrack.clientWidth - t.offsetWidth) / 2;
        thumbTrack.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
    function showMedia(id) {
      for (var n = 0; n < stageItems.length; n++) {
        if (stageItems[n].dataset.mediaId === String(id)) { showIndex(n); return; }
      }
    }
    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { showIndex(n); });
    });
    root.querySelectorAll('[data-shk-prev]').forEach(function (b) { b.addEventListener('click', function () { showIndex(current - 1); }); });
    root.querySelectorAll('[data-shk-next]').forEach(function (b) { b.addEventListener('click', function () { showIndex(current + 1); }); });
    var stage = root.querySelector('.shk-stage');
    if (stage && stageItems.length > 1) {
      var sx = null, sy = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showIndex(current + (dx < 0 ? 1 : -1));
        sx = sy = null;
      }, { passive: true });
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') showIndex(current - 1);
        if (e.key === 'ArrowRight') showIndex(current + 1);
      });
    }

    /* ----- choices ----- */
    function selectFeel(node, fromOutside) {
      if (!node || node.disabled) return;
      state.feel = node;
      var d = feelData(node);
      if (d.mediaId) showMedia(d.mediaId);
      render();
      if (fromOutside) toast((root.dataset.toastFeel || 'Feel updated:') + ' ' + d.name);
    }
    function setBase(val, fromOutside) {
      if (!baseId || !baseAvailable) return;
      if (baseRequired) val = true;
      state.base = !!val;
      render();
      if (fromOutside) toast(state.base ? (baseName + ' ' + (root.dataset.toastAdded || 'added to your system')) : (baseName + ' ' + (root.dataset.toastRemoved || 'removed')));
    }

    feels.forEach(function (n) { n.addEventListener('click', function () { selectFeel(n); }); });
    baseBtns.forEach(function (n) { n.addEventListener('click', function () { setBase(n.dataset.shkBase === 'yes'); }); });

    document.addEventListener('shk:select-feel', function (e) {
      var id = String(e.detail && e.detail.variantId);
      var match = feels.filter(function (f) { return f.dataset.variantId === id; })[0];
      if (match) selectFeel(match, true);
    });
    document.addEventListener('shk:set-base', function (e) { setBase(e.detail && e.detail.value, true); });
    document.addEventListener('shk:toggle-base', function () { setBase(!state.base, true); });
    document.addEventListener('shk:request-state', render);

    /* ----- quantity ----- */
    function setQty(v) {
      var n = parseInt(v, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 10) n = 10;
      state.qty = n;
      render();
    }
    root.querySelectorAll('[data-shk-qty-minus]').forEach(function (b) { b.addEventListener('click', function () { setQty(state.qty - 1); }); });
    root.querySelectorAll('[data-shk-qty-plus]').forEach(function (b) { b.addEventListener('click', function () { setQty(state.qty + 1); }); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

    /* ----- add to cart ----- */
    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg || '';
      errorBox.classList.toggle('is-visible', !!msg);
    }

    function addToCart() {
      if (!state.feel || !atcBtn) return;
      showError('');
      var f = feelData(state.feel);
      var props = {};
      if (propKey) props[propKey] = systemLabel;

      var items = [{ id: parseInt(f.id, 10), quantity: state.qty, properties: props }];
      if (state.base) items.push({ id: parseInt(baseId, 10), quantity: state.qty, properties: props });

      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;
      atcBtn.textContent = root.dataset.labelAdding || 'Adding...';

      var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
          if (root.dataset.afterAdd === 'stay') {
            atcBtn.classList.remove('is-loading');
            render();
            toast(root.dataset.toastCart || 'Added to cart');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } else {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
          }
        })
        .catch(function (err) {
          atcBtn.classList.remove('is-loading');
          render();
          showError(err.message);
        });
    }
    if (atcBtn) atcBtn.addEventListener('click', addToCart);
    root.querySelectorAll('[data-shk-sticky-atc]').forEach(function (b) {
      b.addEventListener('click', function () { addToCart(); });
    });

    /* ----- Katapult calculator opens with the current system total ----- */
    root.addEventListener('click', function (e) {
      var k = e.target.closest('.btn-katapult-price-calculator');
      if (!k || !root.contains(k)) return;
      e.preventDefault();
      if (typeof window.katapult === 'undefined' || !state.total) return;
      window.katapult.loadPriceCalculator({
        cash_price: Number((state.total / 100).toFixed(2)),
        is_click_on_pre_approve: k.classList.contains('katapult-price-calculator-pre-approve')
      });
    });

    /* ----- sticky bar (mobile) ----- */
    if (sticky && atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atcBtn);
    }

    render();
  }

  /* ----- lower sections: feel cards + base toggle ----- */
  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-shk-pick]');
    if (pick) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('shk:select-feel', { detail: { variantId: pick.dataset.shkPick } }));
      return;
    }
    var tog = e.target.closest('[data-shk-toggle-base]');
    if (tog) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('shk:toggle-base'));
    }
  });

  document.addEventListener('shk:state', function (e) {
    var d = e.detail || {};
    document.querySelectorAll('[data-shk-feelcard]').forEach(function (card) {
      var on = card.dataset.shkFeelcard === String(d.variantId);
      card.classList.toggle('is-on', on);
      var btn = card.querySelector('[data-shk-pick]');
      if (btn) btn.textContent = on ? btn.dataset.labelOn : btn.dataset.labelOff;
    });
    document.querySelectorAll('[data-shk-toggle-base]').forEach(function (btn) {
      btn.hidden = !d.baseAvailable || d.baseRequired;
      btn.textContent = d.base ? btn.dataset.labelRemove : btn.dataset.labelAdd;
      btn.classList.toggle('shk-btn--outline', d.base);
      btn.classList.toggle('shk-btn--primary', !d.base);
    });
    document.querySelectorAll('[data-shk-base-state]').forEach(function (n) {
      n.textContent = !d.baseAvailable ? n.dataset.textUnavailable : (d.base ? n.dataset.textOn : n.dataset.textOff);
    });
  });

  /* ----- unmute button on autoplay videos ----- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-shk-sound]');
    if (!b) return;
    var v = b.parentElement.querySelector('video');
    if (!v) return;
    v.muted = !v.muted;
    if (!v.muted) v.play();
    b.textContent = v.muted ? b.dataset.labelOn : b.dataset.labelOff;
  });

  function boot(scope) {
    (scope || document).querySelectorAll('[data-shk-buybox]').forEach(initBuyBox);
    // lower sections may render before the buy box finishes; ask for a state broadcast
    document.dispatchEvent(new CustomEvent('shk:request-state'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
